<template>
  <div class="item_list">
    <!--检索-->
    <el-row>
      <el-col>
        <el-form
          :inline="true"
          :model="requestData"
          label-width="120px"
          style="text-align: right"
        >
          <el-form-item>
            <el-input
              clearable
              size="medium"
              :placeholder="placeholder"
              v-model="searchText"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-upload
              class="upload-demo"
              ref="upload"
              action="https://yytools-api.mockuai.com/api/test/excel/upload"
              :on-change="handleChange"
              :on-exceed="handleExceed"
              :on-remove="handleRemove"
              :on-success="excelSuccess"
              :on-progress="starUpload"
              :show-file-list="false"
              :limit="limitUpload"
              :auto-upload="true"
            >
              <el-button size="small" type="primary" :loading="loading">{{
                loading ? "正在上传" : "导入excel"
              }}</el-button>
              <div slot="tip" class="el-upload__tip">最多上传50件商品</div>
            </el-upload>
          </el-form-item>
          <el-form-item style="margin-left: 10px">
            <div class="link">
              <a
                href="https://cdn.mockuai.com/tms/items_templateID.xlsx"
                download="上传商品模板.xlsx"
                >下载模板</a
              >
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!--表格数据-->
    <el-table
      v-loading="loading"
      :data="tableData"
      ref="mulitTable"
      stripe
      style="width: 100%; margin-top: 20px"
      @select-all="allSelect"
      @select="selectStore"
    >
      <el-table-column type="selection" width="100"> </el-table-column>
      <el-table-column width="100" label="名称">
        <template slot-scope="scope">
          <img width="90" height="90" :src="scope.row.icon_url" alt="" />
        </template>
      </el-table-column>

      <el-table-column label="名称">
        <template slot-scope="scope">
          {{ scope.row.item_name }}
        </template>
      </el-table-column>

      <el-table-column width="100" label="价格">
        <template slot-scope="scope">
          {{ scope.row[priceField] }}
        </template>
      </el-table-column>

      <el-table-column label="渠道">
        <template slot-scope="scope">
          {{ scope.row.channel_tags || "-" }}
        </template>
      </el-table-column>

      <el-table-column prop="" label="操作" width="100" align="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="
              select(scope.row, idList.indexOf(scope.row.id), scope.$index)
            "
            v-text="idList.indexOf(scope.row.id) !== -1 ? '已选取' : '选取'"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div v-if="tableData" class="pagination-wrapper">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="requestData.count"
        layout="total, prev, pager, next"
        :total="totalNumber"
      >
      </el-pagination>
    </div> -->
    <el-row type="flex" justify="center">
      <div class="bottom-btn-box">
        <el-button class="btn-long" type="primary" @click="closeDialog"
          >关闭</el-button
        >
      </div>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
import Util from "@/js/util";

export default {
  props: {
    // 请求的URL
    url: {
      default: "",
      type: String,
    },
    // 默认请求参数
    params: {
      default: function () {
        return { status: 1 };
      },
      type: Object,
    },
    // 页面配置
    pageData: {
      default: {},
      type: Object,
    },
    // 名称搜索字段
    searchField: {
      default: "name_like",
      type: String,
    },
    // placeholder
    placeholder: {
      default: "根据商品id进行搜索添加",
      type: String,
    },
    // 价格字段
    priceField: {
      default: "promotion_price",
      type: String,
    },
    // 标题字段
    titleField: {
      default: "name",
      type: String,
    },
    // 服务端返回的数组名称
    resultArrayName: {
      default: "item_list",
      type: String,
    },
    // 分页数量
    count: {
      default: 20,
      type: Number,
    },
    // 是否支持多选
    multi: {
      type: Boolean,
      default: false,
    },
    // 已选中的idlist
    idList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      limitUpload: 1,
      fileTemp: null,
      loading: false,
      searchText: "",
      // 表格数据 & 翻页
      tableData: null,
      totalNumber: null,
      currentPage: 1,
      onceChoose: "",
      requestData: {
        // 翻页参数
        offset: 0,
        count: 20,
      },
      channel: [
        {
          name: "快手",
          id: 10,
        },
        {
          name: "花椒",
          id: 20,
        },
        {
          name: "KK",
          id: 30,
        },
        {
          name: "虎牙",
          id: 40,
        },
      ],
      selectOptions: {
        status: [
          { value: 1, text: "上架" },
          { value: 2, text: "下架" },
        ],
      },
      multipleSelection: [],
    };
  },
  watch: {
    deep: true,
    url(val) {
      this.searchText = "";
      Object.assign(this.requestData, this.params);
      this.request();
    },
    params(val) {
      this.searchText = "";
      Object.assign(this.requestData, this.params);
      this.request();
    },
  },
  created() {
    this.requestData.count = this.count;
    //    this.request();
  },
  methods: {
    handleChange(file, fileList) {
      this.fileTemp = file.raw;
    },

    handleRemove(file, fileList) {
      this.fileTemp = null;
    },
    handleExceed() {},
    starUpload() {
      this.loading = true;
    },
    excelSuccess(res) {
      console.log("上传");
      if (res.data && res.data.length) {
        let idList = [];
        res.data.forEach((item) => {
          if (item && item.ID) {
            idList.push(item.ID);
          }
        });
        if (idList.length >= 50) {
          this.loading = false;
          this.$refs.upload.clearFiles();
          this.$message.error("最多添加50个!");
          return;
        }
        this.requestIdList(idList);
      }
      this.$refs.upload.clearFiles();
      this.loading = false;
    },
    requestIdList(idList) {
      lib.api.post({
        api: "ec/b/item/query/composite/item",
        data: {
          item_id_list: JSON.stringify(idList),
        },
        success: (res) => {
          if (res.data && res.data.data && res.data.data.length) {
            res.data.data.forEach((item) => {
              item.promotion_price = Util.filterPrice(item.promotion_price);
              if (item.channel_labels) {
                item.channel_tags = this.getItemChannel(
                  item.channel_labels.split(" ")
                );
              }
            });
          }
          this.tableData = res.data.data;
          this.totalNumber = res.data.data.total_count;
          if (this.pageData.app_type == "seller") {
            this.tableData.forEach((item, index) => {
              this.getSellerItem(item.id, index);
            });
          }
          //          data.data.
          //          if(data.data.item && data.data.item.channel_labels){
          //            this.getItemChannel(data.data.item.channel_labels.split(' '));
          //          }

          //          if(this.pageData.app_type == 'seller'){
          //            this.getSellerItem();
          //            console.log('选择卖家商品')
          //          }else{
          //            console.log('选择买家商品')
          //          }
          this.handleSelectionChange();
        },
        error: (data) => {
          if (data.code == 50004) {
            lib.login.goLogin();
          }
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {},
      });
    },
    request() {
      // 有搜索字段时才设置搜索信息
      if (!this.searchText) {
        return;
      }
      Object.assign(this.requestData, this.params);
      lib.api.get({
        api: this.url,
        data: { id: this.searchText },
        success: (data) => {
          data.data.item.promotion_price = Util.filterPrice(
            data.data.item.promotion_price
          );
          this.tableData = [data.data.item];
          this.totalNumber = data.data.total_count;
          if (data.data.item && data.data.item.channel_labels) {
            this.tableData[0].channel_tags = this.getItemChannel(
              data.data.item.channel_labels.split(" ")
            );
          }
          if (this.pageData.app_type == "seller") {
            this.getSellerItem(this.searchText);
            console.log("选择卖家商品");
          } else {
            console.log("选择买家商品");
          }
        },
        error: (data) => {
          if (data.code == 50004) {
            lib.login.goLogin();
          }
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {},
      });
    },
    getItemChannel(channel_tags) {
      let tempTags = [];
      let tags = "";
      if (channel_tags && channel_tags.length) {
        channel_tags.forEach((item) => {
          switch (item) {
            case "10":
              tempTags.push("快手");
              break;
            case "20":
              tempTags.push("花椒");
              break;
            case "30":
              tempTags.push("kk直播");
              break;
            case "40":
              tempTags.push("虎牙");
              break;
            case "50":
              tempTags.push("映客");
              break;
            case "60":
              tempTags.push("斗鱼");
              break;
            case "70":
              tempTags.push("企鹅小店");
              break;
            case "80":
              tempTags.push("无敌主播");
              break;
            case "90":
              tempTags.push("微视");
              break;
            case "100":
              tempTags.push("全民K歌");
              break;
            case "110":
              tempTags.push("手Q");
              break;
            case "120":
              tempTags.push("魔筷星选");
              break;
            default:
              break;
          }
        });
        tags = tempTags.toString();
      } else {
        tags = "-";
      }
      return tags;
    },
    getSellerItem(item_id, index = 0) {
      lib.api.get({
        api: "ec/c/item/discount/price/get",
        data: { item_id: item_id },
        success: (data) => {
          this.tableData[index].app_type = "seller";
          this.tableData[index].commission_percent =
            data.data.item.commission_percent;
          this.tableData[index].promotion_profit =
            data.data.item.promotion_profit;
        },
        error: (data) => {
          if (data.code == 50004) {
            lib.login.goLogin();
          }
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {},
      });
    },
    search() {
      this.request();
    },
    select(row, index, row_idx) {
      this.$refs.mulitTable.toggleRowSelection(this.tableData[row_idx]);
      if (this.multi) {
        if (index === -1) {
          if (this.idList.length === 50) {
            this.$message.error("最多添加50个!");
            return;
          }
          this.$emit("select", row);
        } else {
          this.$emit("unSelect", row, index);
        }
      } else {
        this.$emit("select", row);
      }
    },
    handleCurrentChange(val) {
      this.requestData.offset = this.requestData.count * (val - 1) || 0;
      this.request();
    },
    closeDialog() {
      this.$emit("close");
    },
    allSelect(selection) {
      this.$emit("allSelect", selection);
    },
    selectStore(selection, row) {
      if (this.multi) {
        if (this.idList.indexOf(row.id) === -1) {
          if (this.idList.length >= 50) {
            this.$message.error("最多添加50个!");
            return;
          }
          this.$emit("select", row);
        } else {
          this.$emit("unSelect", row, this.idList.indexOf(row.id));
        }
      } else {
        this.$emit("select", row);
      }
    },
    handleSelectionChange() {
      // 判断已选的商品
      this.$nextTick(() => {
        if (this.tableData.length) {
          this.tableData.forEach((v, i) => {
            if (this.idList.includes(v.id)) {
              this.$refs.mulitTable.toggleRowSelection(v);
            }
          });
        }
      });
    },
    removerIdList(id) {
      // console.log("删除的下标", index);

      let index = this.tableData.findIndex((v) => v.id === id);
      this.$refs.mulitTable.toggleRowSelection(this.tableData[index]);
    },
  },
};
</script>

<style lang="sass">
.item_list
  height: 600px
  overflow: auto

.el-upload__tip
  color: red !important

.link a
  text-decoration: none
  font-size: 12px
</style>